import { FC } from "react";
import AuthorImage from "../../../AuthorImage/component";

interface AuthorInfoProps {
    author?: {
        name: string;
        image?: string;
    };
}

const AuthorInfo: FC<AuthorInfoProps> = ({ author }) => {
    if (!author || !Object.keys(author).length) return null;

    const { name, image } = author;

    return (
        <div
            className="card-cqw-author-info"
            data-testid="card-cqw-author-info"
        >
            {image && <AuthorImage src={image} />}
            <div className="author-name" data-testid="author-name">
                {name}
            </div>
        </div>
    );
};

export default AuthorInfo;
